import { useQuery } from "@tanstack/react-query";

import useUser from "../auth/useUser";
import NotificationsAPI from "../../api/NotificationsAPI";
import { DefaultFields, Query } from "../../../types/GlobalInterfaces";
import { NotificationEvent } from "../../../components/Navbars/CloudNotifications/NotificationTypes";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";

export type NotificationRecord = NotificationEvent & DefaultFields;

const empty: [] = [];

export default function useFetchNotifications(query: Query, disabled: boolean) {
  const { user, userLoading } = useUser();
  const tenantID = useAtomValue(tenantIDAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const notifications = useQuery({
    queryKey: ["notifications", tenantID, user?._id, query],
    queryFn: () =>
      NotificationsAPI.fetchComments(query).then(
        (data) => data.data.data.notifications
      ),
    enabled: !!user?._id && !disabled && queriesEnabled,
  });

  return {
    notifications: (notifications.data?.data || empty) as NotificationRecord[],
    pagination: notifications.data?.pagination ?? null,
    loading: notifications.isLoading || userLoading || disabled,
  };
}
